import { api } from './config.js'

export const reilmAPI = {
    createUser : async function (body) {
        const response = await api.request({
            url: '/users',
            method: "POST",
            data: body
        })

        return response;
    },

    loginUser : async function (body) {
        const response = await api.request({
            url: '/auth/login',
            method: "POST",
            data: body
        })

        return response;
    },

    getUser : async function (body) {
        const response = await api.request({
            url: '/get-user',
            method: "POST",
            data: body
        })

        return response;
    },

    savePropertyDetails : async function (body) {
        const response = await api.request({
            url: '/properties',
            method: "POST",
            data: body
        })

        return response;
    },

    updatedPropertiesDetails : async function (id, body) {
        const response = await api.request({
            url: `/properties/${id}`,
            method: "PATCH",
            data: body
        })

        return response;
    },

    archivePropertiesBatch : async function (body) {
        const response = await api.request({
            url: '/properties/bulk/archive',
            method: "PATCH",
            data: body
        })

        return response;
    },

    deleteProperty : async function (id) {
        const response = await api.request({
            url: `/properties/${id}`,
            method: "DELETE",
        })

        return response;
    },

    deletePropertiesBatch : async function (body) {
        const response = await api.request({
            url: '/properties/bulk',
            method: "DELETE",
            data: body
        })

        return response;
    },

    getTags: async function () {
        const response = await api.request({
            url: '/tags',
            method: "GET",
        })
        return response;
    },

    createTag: async function (body) {
        const response = await api.request({
            url: '/tags',
            method: "POST",
            data: body,
        })
        return response;
    },

    updateTag: async function (id, body) {
        const response = await api.request({
            url: `/tags/${id}`,
            method: "PATCH",
            data: body,
        })
        return response;
    },

    deleteTag: async function (id) {
        const response = await api.request({
            url: `/tags/${id}`,
            method: "DELETE",
        })
        return response;
    },

    getProperties: async function () {
        const response = await api.request({
            url: '/properties',
            method: "GET",
        })
        return response;
    },

    getProperty: async function (id) {
        const response = await api.request({
            url: `/properties/${id}`,
            method: "GET",
        })
        return response;
    },

    toggleArvComp: async function (propertyId, compId, archived) {
        const response = await api.request({
            url: `/properties/${propertyId}/arv/comps/${compId}`,
            method: 'PATCH',
            data: { archived },
        })
        return response
    },

    searchArvComps: async function (id, criteria) {
        const response = await api.request({
            url: `/properties/${id}/arv/search`,
            method: 'POST',
            data: criteria,
        })
        return response
    },

    searchAddress: async function (body) {
        const response = await api.request({
            url: 'https://realtor-search.p.rapidapi.com/properties/auto-complete',
            method: "GET",
            headers: {
                'x-rapidapi-key': 'fa8e2a0342msh146cfd80719f0d0p160552jsnf0135784e8e6',
                // c
                
                'x-rapidapi-host': 'realtor-search.p.rapidapi.com'
            },
            params: {
                input: body
            },
        })

        return response;
    },

    realtorPropertyDetail: async function (body) {
        const response = await api.request({
            url: 'https://realtor-search.p.rapidapi.com/properties/detail',
            method: "GET",
            headers: {
                'x-rapidapi-key': 'fa8e2a0342msh146cfd80719f0d0p160552jsnf0135784e8e6',
                'x-rapidapi-host': 'realtor-search.p.rapidapi.com'
            },
            params: {
                propertyId: body
            },
        })
        return response;
    },

}